/* global structuredClone */
import 'core-js/actual/structured-clone';

export default structuredClone;
